import { LLMBrainInterface } from "@swivl-mono/types";
import { Input } from "@swivl-mono/ui";
import * as React from "react";

import { TagInput } from "../../Components/TagInput/TagInput";
// import _ from 'lodash'

import { BrainsModel } from "../../Models/Brains/Brains.Model";
import "./BrainsView.scss";

interface Props {
  brain: LLMBrainInterface;
}
export default function LLMBrainView(props: Props) {
  const { brain } = props;

  return (
    <div className="BrainsView LLMBrainsView">
      <TagInput
        label="Prompt"
        value={brain.data.prompt}
        onBlur={() => {
          BrainsModel.updateBrain(brain, true);
        }}
        onChange={(event) => {
          let newBrain = { ...brain };
          newBrain.data.prompt = event.target.value;
          BrainsModel.updateBrain(newBrain, false);
        }}
      />
      <br />
      <Input
        label="Number of Messages to Include After Prompt"
        value={String(brain.data.numberOfMessagesToInclude)}
        type="number"
        onBlur={() => {
          BrainsModel.updateBrain(brain, true);
        }}
        onChange={(event) => {
          let newBrain = { ...brain };
          newBrain.data.numberOfMessagesToInclude = parseInt(event.target.value) ?? 0;
          BrainsModel.updateBrain(newBrain, false);
        }}
      />

      <Input
        value={String(brain.data.numberOfTokensInResponse)}
        type="number"
        onBlur={() => {
          BrainsModel.updateBrain(brain, true);
        }}
        onChange={(event) => {
          let newBrain = { ...brain };
          newBrain.data.numberOfTokensInResponse = parseInt(event.target.value) ?? 0;
          BrainsModel.updateBrain(newBrain, false);
        }}
      />
    </div>
  );
}
